const toObject = (item, options) => {
	if (typeof item === 'object' && item !== null) return item
	const match = options.find(o => o.value === item)
	return match ?? { value: item, label: String(item) }
}

const needsEnrich = arr => Array.isArray(arr) && arr.length > 0 && arr.some(i => typeof i !== 'object')

export function enrichFilterIds(fieldKey, options, drawerSignal, originalSignal) {
	if (needsEnrich(drawerSignal.peek()[fieldKey])) {
		drawerSignal.value = {
			...drawerSignal.value,
			[fieldKey]: drawerSignal.value[fieldKey].map(i => toObject(i, options)),
		}
	}
	if (originalSignal.peek() && needsEnrich(originalSignal.peek()[fieldKey])) {
		originalSignal.value = {
			...originalSignal.value,
			[fieldKey]: originalSignal.value[fieldKey].map(i => toObject(i, options)),
		}
	}
}
